const TestIds = {
  login: {
    input: {
      email: 'login-email--input',
      password: 'login-password--input',
      mfaOptions: 'login-mfa-options--input',
      mfaCode: 'login-mfa-code--input',
    },
    button: {
      bypass: 'login-bypass--button',
      continue: 'login-continue--button',
      login: 'login--button',
      cancel: 'login-cancel--button',
      forgot: 'forgot-password--button',
      resendMfa: 'login-resend-mfa--button',
      reselectMfa: 'login-reselect-mfa--button',
    },
  },
  common: {
    tooltip: {
      icon: 'common-tooltip--icon',
    },
  },
  modals: {
    chatHistory: {
      view: 'modals-chat-history--view',
    },
  },
  visits: {
    measurementBasedCare: {
      view: 'visits-mbc--view',
      mbcColumn: {
        score: 'visits-mbc-column-score--value',
        label: 'visits-mbc-column-label--value',
        button: 'visits-mbc-column--button',
        modals: {
          view: 'visits-mbc-assessment-details--view',
        },
      },
      memberIndication: 'visits-mbc-indication--view',
      previousMeasurements: 'visits-mbc-previous-measurements--view',
    },
  },
  visitButtons: {
    start: 'start-visit-button',
    continue: 'continue-visit-button',
    finish: 'finish-visit-button',
    cancel: 'cancel-visit-button',
  },
  dashboard: {
    main: {
      visit: {
        tabs: {
          patient: {
            lifestyle: {
              smoke: 'dashboard-visit-tabs-patient-lifestyle-smoke--value',
              vape: 'dashboard-visit-tabs-patient-lifestyle-vape--value',
              drink: 'dashboard-visit-tabs-patient-lifestyle-drink--value',
              sexuallyActive: 'dashboard-visit-tabs-patient-lifestyle-sexually-active--value',
            },
            buttons: {
              cardContentEdit: (type: string) => `dashboard-visit-tabs-patient-card-content-edit-${type}--button`,
              cardContentDelete: (type: string) => `dashboard-visit-tabs-patient-card-content-delete-${type}--button`,
              editMedicalHistory: 'dashboard-visit-tabs-patient-card-content-edit-Medical History--button',
              addMedication: 'dashboard-visit-tabs-patient-card-content-edit-Medications--button',
              addAllergy: 'dashboard-visit-tabs-patient-card-content-edit-Allergies--button',
              addFamilyHistory: 'dashboard-visit-tabs-patient-card-content-edit-Family History--button',
            },
          },
          clientCard: {
            oldProtocols: 'dashboard-visit-tabs-client-card-old--view',
            newProtocols: 'dashboard-visit-tabs-client-card-new--view',
            crisisManagement: {
              view: 'dashboard-visit-tabs-client-card-crisis-management--view',
            },
          },
          medical: {
            prescriptionsTable: 'dashboard-visit-tabs-medical-prescriptions--table',
            medicationsTable: 'dashboard-visit-tabs-medical-medications--table',
            allergies: {
              input: {
                allergy: 'allergy-input',
                allergicReaction: 'allergic-reaction-input',
              },
            },
          },
        },
      },
    },
  },
  intake: {
    jumpToMissing: 'intake--jumpToMissing--button',
  },
  policies: {
    view: 'policies--view',
  },
}

Object.freeze(TestIds)

export default TestIds
